// import React from 'react';
// import { 
//   Box, 
//   Typography, 
//   Container, 
//   Divider, 
//   Paper,
//   Card,
//   CardContent,
//   CardHeader,
//   Grid
// } from '@mui/material';
// import GavelIcon from '@mui/icons-material/Gavel';
// import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
// import InfoIcon from '@mui/icons-material/Info';
// import WarningIcon from '@mui/icons-material/Warning';

// const RockkpayCancellationRefundPolicy = () => {
//   const currentDate = new Date().toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric'
//   });

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
//         {/* Header Section */}
//         <Box textAlign="center" mb={4}>
//           <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
//             <CurrencyExchangeIcon sx={{ mr: 1, fontSize: 40, verticalAlign: 'middle' }} />
//             RockkPay Cancellation and Refund Policy
//           </Typography>
//           <Typography variant="subtitle1" color="text.secondary">
//             PAYSTREAM TECHNOLOGY PRIVATE LIMITED
//           </Typography>
//           <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//             Registration Number: 07AAOCP7610E1ZD
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Last Updated: {currentDate}
//           </Typography>
//         </Box>

//         <Divider sx={{ mb: 4 }} />

//         {/* Introduction */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Introduction
//           </Typography>
//           <Typography variant="body1" paragraph>
//             You acknowledge and agree to all of the terms, conditions, and policies without any constraints or restrictions 
//             by downloading, accessing and using RockkPay.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We retain the right to modify the terms at any moment without providing you with prior notice. You agree to obey 
//             and be bound by the terms as modified if you continue to use RockkPay after any such changes. The terms take into 
//             account any supplementary terms and conditions, disclaimers, privacy policies, and other rules that may be relevant 
//             to particular services, sections of this website, RockkPay, or other circumstances.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             Refund Details, Refund Summaries, Amount to be Refunded, Transaction Status (Pending, Failed, Completed), and 
//             Transaction Instrument (UPI, Credit Card, Debit Card, Wallet) are all explained in the RockkPay Refund Policy.
//           </Typography>
//         </Box>

//         {/* Policy Points */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <GavelIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Cancellation and Refund Terms
//           </Typography>

//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>1.</strong> You (the user) also acknowledge that accessing or using the RockkPay website or mobile application 
//               constitutes your implicit acceptance of this disclaimer.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>2.</strong> All payments made through RockkPay for mobile / DTH recharge, bill pay, P2P transfer or any other 
//               payment processed by YOU on RockkPay platform, merchant partners accepting RockkPay wallet as a payment option shall 
//               be final and not be responsible for any error and omission by YOU or Merchant partners. Such transactions cannot be 
//               refunded, returned, or cancelled once initiated.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>3.</strong> During any transaction between a user and a merchant, vendor, or service provider, RockkPay does 
//               not acquire ownership of any goods or services offered by the merchant. At no point does RockkPay make any claim or 
//               assert any right regarding the goods or services that the merchant is providing to the customer.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>4.</strong> RockkPay has no authority over fees associated with cancellations or refunds. If there is a 
//               cancellation or refund, it will be regulated by the terms and conditions of the merchant or vendor, not the aggregator. 
//               RockkPay will not be liable for any charges associated with refunds or cancellations.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>5.</strong> If you make a payment by mistake, RockkPay is not responsible for the refund or to take it back.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>6.</strong> If you accidentally send money to the wrong person or for the wrong amount, RockkPay is not responsible, 
//               and your only option is to contact the third party to whom the money was sent to request a refund (if any).
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>7.</strong> All purchases made through the RockkPay platform, including prepaid recharges, are final and cannot be 
//               returned or exchanged. You are accountable for the cell or DTH account number that you purchased the prepaid recharge for 
//               as well as any associated fees. Also, you are accountable for all data card and similar recharge service information as well 
//               as any associated fees, for any prepaid recharge transaction made for services requiring an inaccurate data card, incorrect 
//               mobile, or incorrect DTH account number.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>8.</strong> RockkPay disclaims any liability for any losses, damages, or other consequences that may result from any 
//               user's actions on its website or mobile application, whether intentional or not. User/You should expressly acknowledge that 
//               RockkPay is just a payment facilitator and middleman and that it is released from any liability as a result.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>9.</strong> Please read the terms and conditions that the merchant or vendor has given on their website or other 
//               platform. Your inability to access such terms and conditions or any loss brought on by such terms and conditions or their 
//               absence are not the fault of RockkPay. You agree and understand that the vendor and you are the only parties to the actual 
//               sale contract. The published details and descriptions of websites and apps run by the aggregator of the merchant or vendor 
//               are not within the control or prevention of RockkPay, and the company is not liable for their contents.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>10.</strong> The accuracy of the aggregator's content or listings; the existence, calibre, safety, or legality of 
//               the things presented and the ability of the aggregator and merchant/vendor to sell goods or render services are not under 
//               the aggregator's control to RockkPay.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>11.</strong> At no time during any transaction between you and the aggregator, merchant, or vendor does RockkPay assume 
//               ownership of any listings, bookings, or services provided by the aggregator, merchant, or vendor. At no stage does RockkPay 
//               make any claims or assertions regarding the same that has been made available to you by the aggregator, merchant, or vendor.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>12.</strong> You should get in touch with the specific aggregator or merchant/vendor directly as they are exclusively 
//               responsible for the material, listings, and bookings they make available through the RockkPay platform. If you would need 
//               further information, we kindly ask that you get in touch with the seller, merchant, or service provider. You can also confirm 
//               the information on their websites.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>13.</strong> Despite anything to the contrary contained herein, the service, the interface, the API work, and their 
//               respective information, pricing and data, and availability are subject at any time and from time to time to human, mechanical, 
//               typographical, or other errors, oversights, mistakes, limitations, delays, and service interruptions, including, without 
//               limitation, as may be caused in whole or in part by, related to, or arising out of computer hardware and software, 
//               telecommunications equipment, or any other cause.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>14.</strong> Under no circumstances will the user receive a return for any money that was sent incorrectly or for any 
//               other reason.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>15.</strong> RockkPay is not liable for any prepaid recharge purchases made using erroneous information from a data 
//               card, DTH account, mobile number, or FASTag. Every successful prepaid recharge sale made through RockkPay is complete with 
//               details. All successful prepaid recharge sales made through RockkPay are final; no returns or exchanges are accepted. You 
//               are accountable for the cell or DTH account number associated with the prepaid recharge you purchase, along with any 
//               associated fees.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>16.</strong> RockkPay is not a party to the agreement between the user and the merchant establishment, as stated in 
//               the Terms and Conditions. Any advertising or merchant linked to RockkPay website is not endorsed by the company.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>17.</strong> RockkPay is not required to keep an eye on the services or products that the user uses from the merchant 
//               establishment. For all responsibilities under the agreement, not just the merchant establishment's warranties or guarantees. 
//               Every problem or grievance should be resolved directly between the user and the merchant business, for any shortcomings in 
//               products or services that were acquired using a RockkPay wallet.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>18.</strong> RockkPay is under no obligation to monitor the merchant establishment's service, products used by the 
//               user. For all obligations under the contract including (without limitation) warranties or guarantees the merchant establishment. 
//               User should be the direct resolver with the merchant establishment for every dispute or complaint. For any deficiency in goods 
//               and/or services purchased using RockkPay wallet.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>19.</strong> Refund of any payment made erroneously by the user to any merchant establishment or an erroneous transfer 
//               to any person will not be made by RockkPay in any circumstances.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>20.</strong> Any web-link on the platform to a third-party site is not an endorsement of that web-link. User shall be 
//               subject to the terms and conditions in relation to that web-link, by using or browsing any such other web-link.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>21.</strong> RockkPay records shall be binding as the conclusive evidence of the transactions carried out through use 
//               of the wallet, in the event of any dispute.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>22.</strong> In case, If the Account holder initiates fund Transfer to an unintended or incorrect account, RockkPay 
//               will not be responsible for recovering the money.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>23.</strong> To the provision of any fund transfer and fund collection facility provided/facilitated by RockkPay, the 
//               following terms and conditions shall be applicable. In case of entering any wrong beneficiary details to RockkPay at the time 
//               of availing the said facility like incorrect virtual payment address or incorrect mobile number or account number or IFSC code, 
//               user shall be solely responsible, due to which the fund is transferred to an incorrect beneficiary. Execution of payment order 
//               by RockkPay become irrevocable, has to be agreed by the user.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>24.</strong> All the responsibility of Accuracy and authenticity of the instructions provided to RockkPay, if is in the 
//               form and manner prescribed by RockkPay, will be taken by user and shall be considered to be enough to operate the said Facility. 
//               To verify the instructions RockkPay shall not be required independently. If to stop or prevent the implementation of any payment 
//               order issued by the user, RockkPay has no liability if it unable to do so. User cannot revoke the payment order subsequently 
//               once the order is issued.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>25.</strong> The user only has the authority for his/her decisions and sole responsibility for all instructions, requests, 
//               directives, orders, directions entered by the user.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>26.</strong> Refunds issued by merchants the other users if any will be credited into user's RockkPay wallet account, 
//               in case of any refund of any Product or services.
//             </Typography>
//           </Box>
          
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body1" paragraph>
//               <strong>27.</strong> The cashback amount will be rolled back in RockkPay wallet.
//             </Typography>
//           </Box>
//         </Box>

//         {/* Important Notice */}
//         <Card sx={{ mb: 4, bgcolor: '#fff3e0' }}>
//           <CardHeader 
//             title="Important Notice" 
//             titleTypographyProps={{ variant: 'h6' }}
//             avatar={<WarningIcon sx={{ color: '#ed6c02' }} />}
//             sx={{ bgcolor: '#ffcc80', color: '#e65100' }}
//           />
//           <CardContent>
//             <Typography variant="body2" paragraph>
//               By using RockkPay services, you acknowledge that you have read, understood, and agree to be bound by this Cancellation 
//               and Refund Policy. This policy clearly states that most transactions are final and cannot be reversed once initiated. 
//               Please double-check all transaction details before confirming.
//             </Typography>
//           </CardContent>
//         </Card>

//         {/* Contact Information */}
//         <Card sx={{ mb: 4, bgcolor: '#f5f5f5' }}>
//           <CardHeader title="Contact Information" />
//           <CardContent>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" gutterBottom>
//                   <strong>Address:</strong>
//                 </Typography>
//                 <Typography variant="body2" paragraph>
//                 PAYSTREAM TECHNOLOGY PRIVATE LIMITED<br />
//                   Unit No.355, Plot No 4,Rohini Sector-14,NEW DELHI,Delhi,110085
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" gutterBottom>
//                   <strong>Customer Support:</strong>
//                 </Typography>
//                 <Typography variant="body2" paragraph>
//                   Email:rockkpay@gmail.com<br />
            
//                 </Typography>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Paper>
//     </Container>
//   );
// };

// export default RockkpayCancellationRefundPolicy;

import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Divider, 
  Paper,
  Card,
  CardContent,
  CardHeader,
  Grid
} from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const RockkpayCancellationRefundPolicy = () => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        {/* Header Section */}
        <Box textAlign="center" mb={4}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            <CurrencyExchangeIcon sx={{ mr: 1, fontSize: 40, verticalAlign: 'middle' }} />
            RockkPay Cancellation and Refund Guidelines
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            PAYSTREAM TECHNOLOGY PRIVATE LIMITED
          </Typography>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Registration Number: 07AAOCP7610E1ZD
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Updated On: {currentDate}
          </Typography>
        </Box>

        <Divider sx={{ mb: 4 }} />

        {/* Introduction */}
        <Box mb={4}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
            <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Overview
          </Typography>
          <Typography variant="body1" paragraph>
            By downloading, accessing, or utilizing RockkPay, you fully consent to all terms, conditions, and policies without any limitations or reservations.
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the authority to update these terms at any time without prior notification. Should you continue using RockkPay following any modifications, you agree to comply with and be governed by the updated terms. These terms encompass any additional terms and conditions, disclaimers, privacy statements, and other regulations that may be applicable to specific services, sections of this website, RockkPay, or other situations.
          </Typography>
          <Typography variant="body1" paragraph>
            The RockkPay Refund Policy outlines Refund Information, Refund Overviews, Refundable Amounts, Transaction Status Categories (Pending, Failed, Completed), and Transaction Methods (UPI, Credit Card, Debit Card, Wallet).
          </Typography>
        </Box>

        {/* Policy Points */}
        <Box mb={4}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
            <GavelIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Cancellation and Refund Provisions
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>1.</strong> You (the customer) acknowledge that using or accessing the RockkPay website or mobile app implies your tacit acceptance of this disclaimer.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>2.</strong> All transactions conducted through RockkPay for mobile/DTH recharges, bill payments, peer-to-peer transfers, or any other payments processed by YOU on the RockkPay platform or merchant partners accepting RockkPay wallet as a payment option are conclusive and not eligible for any adjustments due to errors or omissions by YOU or Merchant partners. Such transactions cannot be refunded, returned, or canceled once they have begun.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>3.</strong> RockkPay does not obtain ownership of any products or services offered by merchants during any transaction between a customer and a merchant, vendor, or service provider. RockkPay never claims or asserts any rights regarding the products or services that the merchant delivers to the customer.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>4.</strong> RockkPay has no control over cancellation or refund fees. Any cancellation or refund will be governed by the merchant's or vendor's terms and conditions, not the aggregator's. RockkPay bears no responsibility for any refund or cancellation charges.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>5.</strong> RockkPay assumes no responsibility for refunding or reversing payments made in error.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>6.</strong> Should you mistakenly transfer funds to an incorrect recipient or for an incorrect amount, RockkPay bears no responsibility, and your sole recourse is to contact the third party who received the funds to request a refund (if possible).
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>7.</strong> All purchases made via the RockkPay platform, including prepaid recharges, are final and ineligible for return or exchange. You are responsible for the mobile or DTH account number for which you purchased the prepaid recharge and any associated costs. Furthermore, you are accountable for all data card and similar recharge service details and any related fees for any prepaid recharge transaction involving incorrect data card, mobile, or DTH account information.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>8.</strong> RockkPay disclaims liability for any losses, damages, or consequences resulting from any user's actions on its website or mobile application, whether deliberate or not. Users/You explicitly acknowledge that RockkPay functions solely as a payment facilitator and intermediary and is therefore exempt from any liability.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>9.</strong> Please review the terms and conditions provided by the merchant or vendor on their website or other platforms. RockkPay is not responsible for your inability to access such terms and conditions or any losses resulting from such terms and conditions or their absence. You understand and agree that the actual sales contract exists solely between you and the vendor. RockkPay cannot control or prevent the published details and descriptions on websites and apps operated by the merchant's aggregator, and the company is not liable for their content.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>10.</strong> RockkPay has no control over the aggregator's content or listing accuracy; the existence, quality, safety, or legality of the items presented; or the ability of the aggregator and merchant/vendor to sell goods or provide services.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>11.</strong> RockkPay never assumes ownership of any listings, bookings, or services provided by the aggregator, merchant, or vendor during any transaction between you and them. At no point does RockkPay make any claims or assertions regarding what has been made available to you by the aggregator, merchant, or vendor.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>12.</strong> You should directly contact the specific aggregator or merchant/vendor as they hold exclusive responsibility for the material, listings, and bookings they offer through the RockkPay platform. For additional information, we request that you contact the seller, merchant, or service provider. You may also verify information on their websites.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>13.</strong> Notwithstanding anything to the contrary contained herein, the service, interface, API work, and their respective information, pricing, data, and availability are subject at any time to human, mechanical, typographical, or other errors, oversights, mistakes, limitations, delays, and service interruptions, including but not limited to those caused wholly or partially by, related to, or arising from computer hardware and software, telecommunications equipment, or any other cause.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>14.</strong> Under no circumstances will users receive refunds for funds sent incorrectly or for any other reason.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>15.</strong> RockkPay is not responsible for prepaid recharge purchases made using incorrect data card, DTH account, mobile number, or FASTag information. Every successful prepaid recharge transaction through RockkPay is complete with details. All successful prepaid recharge transactions via RockkPay are final; no returns or exchanges are permitted. You are responsible for the mobile or DTH account number associated with your prepaid recharge purchase, along with any related fees.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>16.</strong> As stated in the Terms and Conditions, RockkPay is not party to the agreement between users and merchant establishments. Any advertising or merchant linked to the RockkPay website does not constitute endorsement by the company.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>17.</strong> RockkPay is not obligated to monitor services or products that users obtain from merchant establishments. For all responsibilities under the agreement, not just the merchant establishment's warranties or guarantees. Every issue or grievance should be resolved directly between the user and the merchant business for any deficiencies in products or services acquired using a RockkPay wallet.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>18.</strong> RockkPay has no obligation to monitor the merchant establishment's services or products used by the user. For all obligations under the contract including (but not limited to) warranties or guarantees, the merchant establishment is responsible. Users should resolve disputes or complaints directly with the merchant establishment for any deficiency in goods and/or services purchased using the RockkPay wallet.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>19.</strong> RockkPay will not, under any circumstances, refund payments made erroneously by users to any merchant establishment or incorrect transfers to any individual.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>20.</strong> Any web-link on the platform to a third-party site does not constitute an endorsement of that web-link. By using or browsing any such other web-link, users will be subject to the terms and conditions related to that web-link.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>21.</strong> In case of any dispute, RockkPay records shall serve as binding and conclusive evidence of transactions conducted using the wallet.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>22.</strong> If an Account holder initiates fund transfer to an unintended or incorrect account, RockkPay will not be responsible for recovering the funds.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>23.</strong> The following terms and conditions apply to any fund transfer and fund collection facility provided/facilitated by RockkPay. Users shall be solely responsible for entering incorrect beneficiary details to RockkPay when using said facility, such as incorrect virtual payment address, mobile number, account number, or IFSC code, which results in funds being transferred to an incorrect beneficiary. Users must agree that payment order execution by RockkPay becomes irrevocable.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>24.</strong> Users will assume all responsibility for the accuracy and authenticity of instructions provided to RockkPay, if presented in the form and manner prescribed by RockkPay, and shall be considered sufficient to operate the said Facility. RockkPay shall not be required to independently verify the instructions. RockkPay has no liability if unable to stop or prevent the implementation of any payment order issued by the user. Once issued, users cannot subsequently revoke payment orders.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>25.</strong> Users maintain sole authority and responsibility for all their decisions, instructions, requests, directives, orders, and directions entered.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>26.</strong> In case of any product or service refund, refunds issued by merchants or other users, if any, will be credited to the user's RockkPay wallet account.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" paragraph>
              <strong>27.</strong> Any cashback amount will be returned to the RockkPay wallet.
            </Typography>
          </Box>
        </Box>

        {/* Important Notice */}
        <Card sx={{ mb: 4, bgcolor: '#fff3e0' }}>
          <CardHeader 
            title="Critical Advisory" 
            titleTypographyProps={{ variant: 'h6' }}
            avatar={<WarningIcon sx={{ color: '#ed6c02' }} />}
            sx={{ bgcolor: '#ffcc80', color: '#e65100' }}
          />
          <CardContent>
            <Typography variant="body2" paragraph>
              By utilizing RockkPay services, you confirm that you have read, comprehended, and consent to be governed by this Cancellation and Refund Policy. This policy explicitly states that most transactions are conclusive and irreversible once initiated. Please verify all transaction details carefully before confirmation.
            </Typography>
          </CardContent>
        </Card>

        {/* Contact Information */}
        <Card sx={{ mb: 4, bgcolor: '#f5f5f5' }}>
          <CardHeader title="Get in Touch" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Location:</strong>
                </Typography>
                <Typography variant="body2" paragraph>
                PAYSTREAM TECHNOLOGY PRIVATE LIMITED<br />
                  Unit No.355, Plot No 4,Rohini Sector-14,NEW DELHI,Delhi,110085
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Support Team:</strong>
                </Typography>
                <Typography variant="body2" paragraph>
                  Email:rockkpay@gmail.com<br />
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};

export default RockkpayCancellationRefundPolicy;